import { AxiosError } from "axios"

function addToSentry(err: AxiosError) {
  // err.response?.status
}

export default addToSentry
